module.exports = __webpack_public_path__ + "static/media/1017322.5da882cb.jpg";